import axios from 'axios';
import { TravelArrangementsData } from 'components/employee-portal/travel-arrangements/types';
import { TRAVEL_ARRANGEMENTS } from 'RestAPIs/endpoints';

export const getTravelArrangements = (employeeId: number) =>
  axios.get<TravelArrangementsData[]>(TRAVEL_ARRANGEMENTS, {
    pathParams: { employeeId }
  });

export const getTravelArrangementsById = (
  employeeId: number,
  empTrvArrangementId: number
) =>
  axios.get<TravelArrangementsData>(
    `${TRAVEL_ARRANGEMENTS}/${empTrvArrangementId}`,
    {
      pathParams: { employeeId }
    }
  );

export const addTravelArrangements = (
  employeeId: number,
  payload: TravelArrangementsData
) =>
  axios.post<TravelArrangementsData>(TRAVEL_ARRANGEMENTS, payload, {
    pathParams: { employeeId }
  });

export const updateTravelArrangements = (
  employeeId: number,
  payload: TravelArrangementsData
) =>
  axios.put<TravelArrangementsData>(TRAVEL_ARRANGEMENTS, payload, {
    pathParams: { employeeId }
  });

export const removeTravelArrangements = (
  employeeId: number,
  empTrvArrangementId: number
) =>
  axios.delete(`${TRAVEL_ARRANGEMENTS}/${empTrvArrangementId}`, {
    pathParams: { employeeId }
  });
